import { useEffect } from 'react'
import { useStyles } from './style'
import { Box } from '@material-ui/core'
import { useHistory } from 'react-router'
import { useSession } from '../../context/SessionContext'
// import commonStyles from '../../styles/common.module.css'
// import { Box, Link, Typography } from '@material-ui/core'

/**
 * Custom `Home` component declaration.
 * @return Home
*/
const Home = (): JSX.Element => {
  const history = useHistory()
  const { autenticated } = useSession()
  const classes = useStyles()

  // This is used to redirect the app.
  useEffect(() => {
    if (autenticated) {
      history.push('/docengine')
    }
  }, [autenticated, history])

  return (
    <Box className={classes.container}>
      <iframe
        src="https://justiexpressdev.github.io/landing/index.html"
        className={classes.iframe}
      ></iframe>
    </Box>
  )
}

export default Home